module.exports = __webpack_public_path__ + "img/1_2-parcheggio-1-bici.e0e4e8c4.png";